<template>
  <div>
    <a-row type="flex" justify="space-around">
      <a-col :span="11">
        <a-input-number
          placeholder=""
          allow-clear
          :min="0"
          class="input"
          :value="range[0]"
          @change="(v) => handleChange(v, 0)"
        />
      </a-col>
      <a-col :span="2" class="symbol">~</a-col>
      <a-col :span="11">
        <a-input-number
          placeholder=""
          allow-clear
          :min="0"
          class="input"
          :value="range[1]"
          @change="(v) => handleChange(v, 1)"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'intervalNumber',
  props: {
    value: {
      type: Array,
    },
  },
  watch: {
    value: {
      handler(v) {
        if (v) {
          this.range = [...(v || [undefined, undefined])];
          return;
        }
        this.range = [undefined, undefined];
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleChange(v, i) {
      const l = this.range;
      if (i === 1 && l[0]) {
        Number(v) < Number(l[0]) && (v = undefined);
      }
      l[i] = v;
      this.$emit('input', [...l]);
    },
  },
  data() {
    return {
      range: [undefined, undefined],
    };
  },
};
</script>

<style lang="less" scoped>
.symbol {
  text-align: center;
}
.input {
  width: 100%;
}
</style>
